export default function SectionContainerAlt({ children }) {
  return (
    <div className='w-full py-6 xl:pt-16 xl:pb-10 bg-theme-intel-2020-e-gray-t2'>
      <div className='px-5 md:px-[60px] lg:w-full lg:max-w-container-lg lg:mx-auto xl:container'>
        {children}
      </div>
    </div>
  );
}
